import { View } from '@lernetz/ts-lib';

import {FooterLink} from './FooterLink';
import footerTemplate from './Footer.html';


export class FooterView extends View {

    constructor(links: FooterLink[]) {
        super({ data: { links }, template: footerTemplate });
    }
}
